import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { env } from "../../../../../env";
import axiosInstance from "../../../../globalInspector/axiosInstance";

const baseUrl = env.REACT_APP_BASE_URL;

export const getServices = createAsyncThunk("getServices", async (values) => {
  var requestOptions = {
    method: "GET",
    redirect: "follow",
    headers: {
      "Content-Type": "application/json",
      "X-Api-Key": sessionStorage.getItem("q2p_token"),
    },
  };

  return await fetch(
    `${baseUrl}/platform_services${
      values?.service_id ? "/" + values?.service_id : ""
    }?page_no=${values?.page_no || 1}&page_size=${
      values?.page_size || 15
    }&search_string=${
      values?.search_string || ""
    }&sort_by=${values?.sort_by ?? ""}`,
    requestOptions,
  )
    .then((response) => response.json())

    .catch((error) => undefined);
});

export const getSpecificService = createAsyncThunk(
  "getSpecificService",
  async (payload, { rejectWithValue }) => {
    const { id } = payload;
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/platform_services/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const servicesSlice = createSlice({
  name: "services",
  initialState: {
    isLoading: false,
    services: null,
    isError: false,

    getSpecificServiceData: null,
    getSpecificServiceIsLoading: true,
    getSpecificServiceError: null,
    //     allDevicesData: null,
    //     allDevicesDataLoading: null,
    //     allDevicesDataError: null,

    //     deleteDeviceStatus: null,
    //     deleteDeviceLoading: null,
    //     deleteDeviceError: null,
    // deviceData:null,
    //     apiToken: null,
    //     apiTokenLoading: null,
    //     apiTokenError: null,
  },
  // reducers: {
  //   setDeviceData: (state, action) => {
  //     state.deviceData = action.payload
  //   }
  // },
  extraReducers: (builder) => {
    builder.addCase(getServices.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getServices.fulfilled, (state, action) => {
      state.isLoading = false;
      state.services = action.payload;
    });
    builder.addCase(getServices.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
    });

    builder.addCase(getSpecificService.fulfilled, (state, action) => {
      state.getSpecificServiceData = action.payload;
      state.getSpecificServiceIsLoading = false;
    });
    builder.addCase(getSpecificService.rejected, (state, action) => {
      state.getSpecificServiceData = null;
      state.getSpecificServiceIsLoading = false;
      state.getSpecificServiceError = action.payload;
    });
    builder.addCase(getSpecificService.pending, (state, action) => {
      state.getSpecificServiceIsLoading = true;
    });

    // builder.addCase(getAllDevices.pending, (state, action) => {
    //   state.allDevicesDataLoading = true;
    // });
    // builder.addCase(getAllDevices.fulfilled, (state, action) => {
    //   state.allDevicesDataLoading = false;
    //   state.allDevicesData = action.payload;
    // });
    // builder.addCase(getAllDevices.rejected, (state, action) => {
    //   state.allDevicesDataError = true;
    //   state.allDevicesData = null;
    // });

    // builder.addCase(deleteDevice.pending, (state, action) => {
    //   state.deleteDeviceLoading = true;
    // });
    // builder.addCase(deleteDevice.fulfilled, (state, action) => {
    //   state.deleteDeviceLoading = false;
    //   state.deleteDeviceStatus = action.payload;
    // });
    // builder.addCase(deleteDevice.rejected, (state, action) => {
    //   state.deleteDeviceError = true;
    //   state.deleteDeviceStatus = null;
    // });

    // builder.addCase(getAPIToken.pending, (state, action) => {
    //   state.apiTokenLoading = true;
    // });
    // builder.addCase(getAPIToken.fulfilled, (state, action) => {
    //   state.apiTokenLoading = false;
    //   state.apiToken = action.payload;
    // });
    // builder.addCase(getAPIToken.rejected, (state, action) => {
    //   state.apiTokenError = true;
    //   state.apiToken = null;
    // });
  },
});

// export const  {setDeviceData} = servicesSlice.actions
export default servicesSlice.reducer;
